"use client";

import React from "react";
import Image from "next/image";
import { useTranslations } from "@/providers/TranslationsProvider";

export default function HeroSection() {
  const { t } = useTranslations();

  const avatars = [
    "https://i.pravatar.cc/150?u=1",
    "https://i.pravatar.cc/150?u=2",
    "https://i.pravatar.cc/150?u=3",
    "https://i.pravatar.cc/150?u=4",
    "https://i.pravatar.cc/150?u=5",
  ];

  return (
    <section className="px-6 mb-6 pt-24 sm:pt-28 animate-fade-in border-b border-black/[0.03] dark:border-white/[0.03] pb-4 sm:pb-6">
      <div className="max-w-3xl mx-auto text-center">
        {/* Social Proof Avatar Stack - Apple Style */}
        <div className="flex flex-col items-center mb-3 sm:mb-4">
          <div className="flex -space-x-2.5 rtl:space-x-reverse">
            {avatars.map((url, i) => (
              <div
                key={i}
                className="w-8 h-8 rounded-full border-2 border-[#F5F5F7] dark:border-[#1D1D1F] overflow-hidden shadow-sm"
                style={{ zIndex: avatars.length - i }}
              >
                <Image
                  src={url}
                  alt={`Patient ${i + 1}`}
                  width={32}
                  height={32}
                  className="object-cover"
                  unoptimized
                />
              </div>
            ))}
          </div>
        </div>

        {/* No forced <br/> between the two title parts — Persian/other
            locales run longer than English and a hardcoded break adds a
            whole extra line on top of the wrap the text already needs. */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1D1D1F] dark:text-[#F5F5F7] mb-2 tracking-tight leading-[1.15]">
          {t("hero.title start", "Find the Best")}{" "}
          <span className="text-[#0066CC]">{t("hero.title highlight", "Specialized Doctors")}</span>
        </h1>

        <p className="text-sm sm:text-base text-[#6E6E73] dark:text-[#86868B] max-w-lg mx-auto leading-relaxed font-medium">
          {t("hero.subtitle", "Book appointments instantly with verified healthcare professionals.")}
        </p>
      </div>
    </section>
  );
}
